import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  container: {
    padding: 5,
    margin: 0,
    width: 335,
    overflowY: 'auto',
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  image: {
    width: '100%',
    padding: '0 !important',
    margin: 0,
    '&:hover': {
      cursor: 'pointer',
    },
  },
}))

export default styles
